<template>
  <div class="mb-4">
    <px-lista-selecao-fornecedores :comprador="requisicao.comprador"
                                   :produtos="requisicao.produtos"
                                   v-model="requisicao.fornecedores"
                                   @resetfornecedor="emitReset"/>
  </div>
</template>

<script>
export default {
  props: {
    requisicao: {
      type: Object,
      required: true,
    },
  },
  methods: {
    emitReset() {
      this.$emit('resetfornecedor');
    },
  },
};
</script>
